import { FC } from 'react';
import { NotAloneStrings } from '../../../utils/strings';
import { Heading } from '../Heading';
import { Texts } from '../Texts';
import styles from './NotAlone.module.scss';
import { Button } from '../Button';
import { TextWithUrl, TextsProps } from '../Texts/textWithUrl';

interface NotAloneProps {
  routeTo: () => void;
}

export const NotAlone: FC<NotAloneProps> = ({ routeTo }) => {
  return (
    <section className={styles.not_alone}>
      <Heading type="h1" className={styles.header}>
        {NotAloneStrings().h1}
      </Heading>

      {NotAloneStrings().p1.map((desc, index) => (
        <Texts key={`DescTexts${index}`} className={styles.desc}>
          {desc}
        </Texts>
      ))}
      <Texts className={styles.desc}>
        <a href={NotAloneStrings().contact.url} target="_blank">
          {NotAloneStrings().contact.urlText}
        </a>
      </Texts>
      {NotAloneStrings().p2.map((desc, index) => (
        <Texts key={`DescTexts${index}`} className={styles.desc}>
          {desc}
        </Texts>
      ))}
      <TextWithUrl
        texts={NotAloneStrings().link as TextsProps[]}
        className={styles.desc}
      />
      <Button className={styles.next_page_navigation} onClick={() => routeTo()}>
        {NotAloneStrings().buttonText}
      </Button>
    </section>
  );
};
